import { Layout } from 'antd';
import React from 'react';
import './index.css';

const { Header, Footer, Content } = Layout;

class Home extends React.Component{
    render(){
        return(
        <div>
          <Layout>
            <Header>Projeto S2</Header>
            <Content>Content</Content>
            <Footer>Footer</Footer>
          </Layout>
        </div>
        )
    }
    
       
}


export default Home;